import { UserManager, WebStorageStateStore } from "oidc-client";
import { API_BASE_URL } from "../../config";

const config = {
  authority: API_BASE_URL + "/api",
  redirect_uri: `${window.location.origin}/authorize-redirect`,
  post_logout_redirect_uri: `${window.location.origin}/`,
  response_type: "code",
  scope: "openid profile email",
  loadUserInfo: true,
  response_mode: "query",
  client_id: "teamrayclient",
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  stateStore: new WebStorageStateStore({ store: window.localStorage }),
  sessionMonitor: false,
  extraQueryParams: { prompt: "login" },
  silent_redirect_uri: `${window.location.origin}/silent-renew.html`,
};

const userManager = new UserManager(config);

export const login = async (provider: "Google" | "Microsoft" | "Facebook") => {
  try {
    const scopes = provider === "Facebook" ? "openid email" : "openid profile email";
    await userManager.signinRedirect({
      extraQueryParams: { provider: provider },
      scope: scopes,
    });
  } catch (error) {
    throw error;
  }
};

export const getUser = () => userManager.getUser();

export const completeSignIn = async () => {
  try {
    await userManager.signinRedirectCallback();
  } catch (error) {
    throw error;
  }
};

export default userManager;
